module.exports = __webpack_public_path__ + "img/favicon.2fad59e3.png";